<template>
  <main class="main-wrapper-website position-relative">
    <MobileGetAppBanner />
    <HeaderPage />
    <AppMain />
    <MobBottomNav />
    <AppDownloadQR />
    <HeeraNotification />
  </main>
</template>

<script>
import HeaderPage from "@/components/fixedComponents/Header.vue";
import AppMain from "./AppMain.vue";
import MobBottomNav from "@/components/fixedComponents/MobBottomNav.vue";
import AppDownloadQR from "@/components/fixedComponents/AppDownloadQR.vue";
import HeeraNotification from "@/components/fixedComponents/HeeraNotification.vue";
import MobileGetAppBanner from "@/components/fixedComponents/MobileGetAppBanner.vue";

export default {
  name: "LayoutPage",
  components: {
    HeaderPage,
    AppMain,
    MobBottomNav,
    AppDownloadQR,
    HeeraNotification,
    MobileGetAppBanner,
  },
};
</script>

<style lang="scss" scoped></style>

